import { useMemo } from 'react';
const getId = (() => {
    let id = 1;
    return () => id++;
})();
export default function useId() {
    return useMemo(() => getId(), []);
}
